import gql from "graphql-tag";

import { Contract, Fragment } from "../types";

import {
  ContractTemplateMinimalFragment,
  CONTRACT_TEMPLATE_MINIMAL_FRAGMENT,
} from "./ContractTemplate";

export const CONTRACT_MINIMAL_FRAGMENT = gql`
  fragment ContractMinimalFragment on Contract {
    id
    document
    contractTemplate {
      ...ContractTemplateMinimalFragment
    }
  }

  ${CONTRACT_TEMPLATE_MINIMAL_FRAGMENT}
`;

export type ContractMinimalFragment = Fragment<
  Contract,
  Pick<Contract, "id" | "document"> & {
    contractTemplate: ContractTemplateMinimalFragment;
  }
>;
